import { makeStyles, Theme, createStyles, Typography } from "@material-ui/core";
import React from "react";
import { WebCrawlingConfigDataRow } from "../../../../../types/config";
import { ElectronAccessor, isValidUrl } from "../../../../../helpers";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      fontSize: "0.875rem",
    },
    typographyUrl: {
      fontSize: "0.875rem",
      color: theme.palette.primary.dark,
    },
  })
);

/** アンカーリンクコンポーネント */
function ActionLink(props: { url: string }) {
  const classes = useStyles();
  const { url } = props;
  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    // [HP稼働]: electronからの修正
    // ElectronAccessor.openExternal(url);
  }

  //--------------------
  // コンポーネント
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href="#" onClick={handleClick}>
      <Typography component="span" className={classes.typographyUrl}>
        {url}
      </Typography>
    </a>
  );
}

interface Props {
  rowData: WebCrawlingConfigDataRow;
}

/** サイト名/URL表示コンポーネント */
export function SiteNameAndUrlRenderComponent(props: Props) {
  const classes = useStyles();

  const { rowData } = props;

  //--------------------
  // コンポーネント
  return (
    <>
      <div>
        <Typography className={classes.typography} component="span">
          {rowData.siteNameAndUrl.siteName}
        </Typography>
      </div>
      <div>
        {isValidUrl(rowData.siteNameAndUrl.url) ? (
          <ActionLink url={rowData.siteNameAndUrl.url} />
        ) : (
          <Typography className={classes.typographyUrl} component="span">
            {rowData.siteNameAndUrl.url}
          </Typography>
        )}
      </div>
    </>
  );
}
